module.exports = "<div class=\"collection\">\n  {{ salle.nom}}\n</div>\n"